import { render } from "./Burger.vue?vue&type=template&id=3580ec4a&scoped=true"
const script = {}

import "./Burger.vue?vue&type=style&index=0&id=3580ec4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3580ec4a"]])

export default __exports__